// extracted by mini-css-extract-plugin
export default {"listServicesPage":"list-services_listServicesPage__7Kqpi","styleWrapper":"list-services_styleWrapper__V8hK2"};